export default "__VITE_ASSET__I2Mu5g4x__"